import type { TFunction } from "i18next";
import type { Decision, RefusalCode } from "../../api/access/decisions";
import { itemKindText } from "../../api/content/processTermWords";

/**
 * The one wording of every module's refusals (SOT-02, accounts.md GS-8): each code once, in
 * `refusals.<code>`, and a missing permission by the name the access screens give it.
 */

export function refusalText(t: TFunction, refusal: RefusalCode): string {
  return t(`refusals.${refusal}`);
}

/** A grant as module A names it (`propose`, `curate:artifact`), in words: "Propose changes", "Curate Artifacts". */
export function needText(t: TFunction, needs: string): string {
  const [permission = needs, kind] = needs.split(":");
  return kind === undefined ? t(`access.permissions.${permission}`) : t("access.chips.curateOne", { kind: itemKindText(kind, t) });
}

/** Why a refused action can't be taken, in one line: a missing permission by its name where the remedy names it. */
export function decisionReason(t: TFunction, decision: Decision): string {
  if (decision.refusal === null) return "";
  if (decision.refusal === "missing_permission" && decision.remedy !== null) return t("refusals.blocked.need", { permission: needText(t, decision.remedy.needs) });
  return refusalText(t, decision.refusal);
}
